/**
 * Display band for a Threat.riskScore. One place for the thresholds, so the threat list,
 * its row highlight and the badge can't disagree.
 *
 *   riskScore < 0   → positive (a good security practice, e.g. tapjacking protection)
 *   0 – 2           → low      (informational)
 *   3 – 5           → medium
 *   6 and above     → high
 */
export const RISK_LEVELS = {
    high: {
        key: "high",
        label: "High risk",
        badge: "bg-red-100 text-red-700 ring-red-600/20",
        row: "bg-red-50 border-red-500",
        text: "text-red-900",
    },
    medium: {
        key: "medium",
        label: "Medium",
        badge: "bg-amber-100 text-amber-800 ring-amber-600/20",
        row: "bg-white border-amber-400",
        text: "text-gray-900",
    },
    low: {
        key: "low",
        label: "Low",
        badge: "bg-gray-100 text-gray-700 ring-gray-500/20",
        row: "bg-white border-transparent",
        text: "text-gray-900",
    },
    positive: {
        key: "positive",
        label: "Positive action",
        badge: "bg-green-100 text-green-800 ring-green-600/20",
        row: "bg-white border-green-500",
        text: "text-gray-900",
    },
};

export function riskLevel(riskScore) {
    const score = Number(riskScore);
    if (!Number.isFinite(score)) return RISK_LEVELS.low;
    if (score < 0) return RISK_LEVELS.positive;
    if (score >= 6) return RISK_LEVELS.high;
    if (score >= 3) return RISK_LEVELS.medium;
    return RISK_LEVELS.low;
}
